/* BARE DROP — storefront behaviour (vanilla, no deps) */
(function () {
  'use strict';

  var fmt = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); };

  /* ── countdown ── */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.dataset.countdown).getTime();
    if (isNaN(target)) return;
    var ids = ['d', 'h', 'm', 's'].map(function (k) { return el.querySelector('[data-cd-' + k + ']'); });
    var pad = function (n) { return String(Math.max(0, n)).padStart(2, '0'); };
    var tick = function () {
      var x = target - Date.now();
      ids[0].textContent = pad(Math.floor(x / 864e5));
      ids[1].textContent = pad(Math.floor(x % 864e5 / 36e5));
      ids[2].textContent = pad(Math.floor(x % 36e5 / 6e4));
      ids[3].textContent = pad(Math.floor(x % 6e4 / 1e3));
    };
    tick(); setInterval(tick, 1000);
  });

  /* ── menu overlay ── */
  var menu = document.getElementById('bareMenu');
  document.querySelectorAll('[data-menu-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (menu) { menu.classList.add('on'); document.body.style.overflow = 'hidden'; } });
  });
  document.querySelectorAll('[data-menu-close]').forEach(function (b) {
    b.addEventListener('click', function () { if (menu) { menu.classList.remove('on'); document.body.style.overflow = ''; } });
  });

  /* ── size guide modal ── */
  var sgm = document.getElementById('sgm');
  document.querySelectorAll('[data-sg-open]').forEach(function (b) {
    b.addEventListener('click', function () { if (sgm) sgm.classList.add('on'); });
  });
  if (sgm) sgm.addEventListener('click', function (e) { if (e.target === sgm) sgm.classList.remove('on'); });
  document.querySelectorAll('[data-sg-close]').forEach(function (b) {
    b.addEventListener('click', function () { if (sgm) sgm.classList.remove('on'); });
  });

  /* ── cart drawer ── */
  var ov = document.getElementById('cartOv'), dr = document.getElementById('cartDr');
  function cartOpen() { if (!dr) return; ov.classList.add('on'); dr.classList.add('on'); document.body.style.overflow = 'hidden'; }
  function cartClose() { if (!dr) return; ov.classList.remove('on'); dr.classList.remove('on'); document.body.style.overflow = ''; }
  if (ov) ov.addEventListener('click', cartClose);
  document.querySelectorAll('[data-cart-close]').forEach(function (b) { b.addEventListener('click', cartClose); });
  document.querySelectorAll('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(cartOpen); });
  });
  addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { cartClose(); if (sgm) sgm.classList.remove('on'); if (menu) menu.classList.remove('on'); }
  });

  var shotsEl = document.getElementById('bareShots');
  var SHOTS = shotsEl ? JSON.parse(shotsEl.textContent) : {};
  function renderCart(cart) {
    var body = document.getElementById('cdItems'), count = document.getElementById('cdCount'),
        total = document.getElementById('cdTotal');
    if (!body) return;
    count.textContent = cart.item_count;
    total.textContent = fmt(cart.total_price);
    if (!cart.items.length) {
      body.innerHTML = '<div class="cd-empty">Your cart is empty.</div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = SHOTS[it.handle] || (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_360x$1$2') : '');
      return '<div class="cd-item">' +
        '<img src="' + img + '" alt="">' +
        '<div>' +
          '<div class="cd-nm">' + it.product_title + '</div>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cd-mt">Size — US ' + it.variant_title + '</div>' : '') +
          '<div class="cd-pr">' + fmt(it.final_line_price) + '</div>' +
          '<div class="cd-qty">' +
            '<button data-line-minus="' + it.key + '">−</button><span>' + it.quantity + '</span>' +
            '<button data-line-plus="' + it.key + '">+</button>' +
          '</div>' +
          '<span class="cd-rm" data-line-remove="' + it.key + '">Remove</span>' +
        '</div></div>';
    }).join('') +
    '<div class="cd-gifts">' +
      '<div class="cd-gl"><span>Comfort Kit</span><span><s>$15</s><b>Included</b></span></div>' +
      '<div class="cd-gl"><span>Dust Bag</span><span><s>$12</s><b>Included</b></span></div>' +
      '<div class="cd-gl"><span>Spare Heel Tips</span><span><s>$8</s><b>Included</b></span></div>' +
      '<div class="cd-gl"><span>Numbered Run Card</span><span><b>Included</b></span></div>' +
    '</div>';
    body.querySelectorAll('[data-line-minus],[data-line-plus],[data-line-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        var key = b.dataset.lineMinus || b.dataset.linePlus || b.dataset.lineRemove;
        var line = cart.items.find(function (i) { return i.key === key; });
        var qty = b.dataset.lineRemove !== undefined ? 0 :
                  b.dataset.linePlus !== undefined ? line.quantity + 1 : Math.max(0, line.quantity - 1);
        fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        }).then(function (r) { return r.json(); }).then(renderCart);
      });
    });
  }
  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }

  /* ── PDP: size select + add to cart ── */
  var pdp = document.getElementById('barePdp');
  if (pdp) {
    var variants = JSON.parse(document.getElementById('bareVariants').textContent);
    var atc = document.getElementById('atc');
    var priceLabel = atc ? atc.dataset.priceLabel : '';
    var chosen = null;
    document.querySelectorAll('.sz:not(.x)').forEach(function (s) {
      s.addEventListener('click', function () {
        document.querySelectorAll('.sz').forEach(function (x) { x.classList.remove('on'); });
        s.classList.add('on');
        chosen = variants.find(function (v) { return String(v.title) === String(s.dataset.size); });
        atc.disabled = false;
        atc.textContent = 'Add to Cart — ' + priceLabel;
      });
    });
    if (atc) atc.addEventListener('click', function () {
      if (!chosen || atc.disabled) return;
      atc.disabled = true; atc.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: chosen.id, quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refreshCart();
      }).then(function () {
        atc.disabled = false; atc.textContent = 'Add to Cart — ' + priceLabel;
        cartOpen();
      }).catch(function () {
        atc.disabled = false; atc.textContent = 'Add to Cart — ' + priceLabel;
      });
    });

    /* gallery slider */
    var track = document.getElementById('strack');
    if (track) {
      var n = track.children.length, i = 0;
      var cur = document.getElementById('scur');
      var go = function (j) {
        i = (j + n) % n;
        track.style.transform = 'translateX(-' + i * 100 + '%)';
        if (cur) cur.textContent = i + 1;
        document.querySelectorAll('#sthumbs span').forEach(function (t, k) { t.classList.toggle('on', k === i); });
      };
      document.querySelectorAll('[data-slide]').forEach(function (b) {
        b.addEventListener('click', function () { go(i + parseInt(b.dataset.slide, 10)); });
      });
      document.querySelectorAll('#sthumbs span').forEach(function (t, k) {
        t.addEventListener('click', function () { go(k); });
      });
      addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(i - 1);
        if (e.key === 'ArrowRight') go(i + 1);
      });
      if (n < 2) document.querySelectorAll('.sarrow,.scount,.sthumbs').forEach(function (x) { x.style.display = 'none'; });
    }

    /* reviews jump */
    var rj = document.getElementById('rwjump');
    if (rj) rj.addEventListener('click', function () {
      var r = document.getElementById('reviews');
      if (r) r.scrollIntoView({ behavior: 'smooth' });
    });
  }

  refreshCart();
})();
